import React from 'react';
import { ThemeMode } from '../../constants/themeConstants';
import { useTheme } from '../../context/ThemeContext';
import './ThemeToggle.css';

export const ThemeToggle: React.FC = () => {
  const { theme, toggleTheme } = useTheme();
  const isDark = theme === ThemeMode.DARK;

  return (
    <button
      className={`theme-toggle ${isDark ? 'theme-toggle-dark' : 'theme-toggle-light'}`}
      onClick={toggleTheme}
      aria-label={`Switch to ${isDark ? ThemeMode.LIGHT : ThemeMode.DARK} mode`}
      title={`Switch to ${isDark ? ThemeMode.LIGHT : ThemeMode.DARK} mode`}
      role="switch"
      aria-checked={isDark}
    >
      <div className="theme-toggle-track">
        {/* Inactive state indicators - small white dots (stars) */}
        <div className="theme-toggle-dots">
          <div className="theme-toggle-dot theme-toggle-dot-large"></div>
          <div className="theme-toggle-dot theme-toggle-dot-small"></div>
        </div>
        
        {/* Sliding thumb/indicator */}
        <div className="theme-toggle-thumb">
          {/* Sun icon for light mode */}
          <svg
            className="theme-toggle-thumb-icon theme-toggle-thumb-icon-sun"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            aria-hidden="true"
          >
            <circle cx="12" cy="12" r="5" />
            <line x1="12" y1="1" x2="12" y2="3" />
            <line x1="12" y1="21" x2="12" y2="23" />
            <line x1="4.22" y1="4.22" x2="5.64" y2="5.64" />
            <line x1="18.36" y1="18.36" x2="19.78" y2="19.78" />
            <line x1="1" y1="12" x2="3" y2="12" />
            <line x1="21" y1="12" x2="23" y2="12" />
            <line x1="4.22" y1="19.78" x2="5.64" y2="18.36" />
            <line x1="18.36" y1="5.64" x2="19.78" y2="4.22" />
          </svg>
          
          {/* Moon icon for dark mode */}
          <svg
            className="theme-toggle-thumb-icon theme-toggle-thumb-icon-moon"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            aria-hidden="true"
          >
            <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z" />
          </svg>
        </div>
      </div>
      <span className="sr-only">Switch to {isDark ? ThemeMode.LIGHT : ThemeMode.DARK} mode</span>
    </button>
  );
};

